import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import './assets/css/styles.scss';
import BootstrapVue, { BootstrapVueIcons } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import VueCookies from 'vue-cookies';
import VueClipboards from 'vue-clipboards';
import Clipboard from 'v-clipboard';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import jQuery from 'jquery';
import vClickOutside from 'v-click-outside';
// import bugsnag from '@bugsnag/js';
// import bugsnagVue from '@bugsnag/plugin-vue';
import emojione from 'emojione';
import VueHighlightJS from 'vue-highlight.js';
// Highlight.js languages (Only required languages)
import HJScss from 'highlight.js/lib/languages/css';
import HJSjavascript from 'highlight.js/lib/languages/javascript';
import HJSjson from 'highlight.js/lib/languages/json';
import HJSxml from 'highlight.js/lib/languages/xml';
import Undo from 'undo.js';
import VueGtag from 'vue-gtag';
import Vue2Filters from 'vue2-filters';
import VueDragscroll from 'vue-dragscroll';
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
import VueObserveVisibility from 'vue-observe-visibility';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import VueSecureHTML from 'vue-html-secure';

import rangy from '../node_modules/rangy/lib/rangy-classapplier';
import App from './App';
import router from './router';
import moment from './helpers/momentz';
import lodash from './helpers/lodash';
import EventBus from './helpers/EventBus';
import hasPermissionInMerchant from './helpers/guards/hasPermissionInMerchant';
import hasPermissionInOrganisation from './helpers/guards/hasPermissionInOrganisation';
import store from './store';
import InfoModal from './plugins/InfoModal/InfoModalPlugin';
import NumberInfoModal from './plugins/NumberInfoModal/NumberInfoModal.plugin';
import PasswordConfirmPluginModal from './plugins/PasswordConfirmModal/PasswordConfirm.plugin';
import ConfirmPluginModal from './plugins/ConfirmModal/Confirm.plugin';
import './helpers/vueFilters';

import MultiselectOverflowFixDirective from './directives/MultiselectOverflowFixDirective';
import ProgressBorderDirective from './directives/ProgressBorder.directive';
import CopyToClipboardDirective from './directives/CopyToClipboard.directive';

import { loadAppData } from './helpers/initializeApp';

import tokenCheck from './helpers/guards/tokenCheck';

import SBCustomWrapperJSONForms from './components/manage/create_assistant/SBCustomWrapperJSONForms';
import BInputWrapper from './components/forms_schema/form_components/bInputWrapper';
import SBDropdownWrapper from './components/forms_schema/form_components/dropdownWrapper';
import SBTextareaWrapper from './components/forms_schema/form_components/SBTextareaWrapper';
import NMBRButtonsWrapper from './components/forms_schema/form_components/NMBRButtonsWrapper';
import NMBRActionsWrapper from './components/forms_schema/form_components/NMBRActionsWrapper.form';
import DividerWrapper from './components/forms_schema/form_components/DividerWrapper.form';
import SkeletonWrapper from './components/forms_schema/form_components/Skeleton.form';
import FileInputWrapper from './components/forms_schema/form_components/file_input/FileInput.form';
import UrlInputWrapper from './components/forms_schema/form_components/UrlInput.form';
import RemoteDataForm from './components/forms_schema/form_components/RemoteData.form';
import NMBRRadioWrapper from './components/forms_schema/form_components/NMBRRadioWrapper.form';
import DurationWrapper from './components/forms_schema/form_components/DurationWrapper.form';
import CustomValidator from './components/forms_schema/form_components/CustomValidator.form';
import QuestionsWrapper from './components/forms_schema/form_components/QuestionsWrapper.form';
import QuestionsListModalWrapper from './components/forms_schema/form_components/questions_list/QuestionsListModalWrapper.form';
import InputListWrapper from './components/forms_schema/form_components/InputListWrapper.form';
import ConversationWrapper from './components/forms_schema/form_components/ConversationWrapper.form';
import WarningBubble from './components/common/widgets/WarningBubble';
import WidgetSources from './components/formElements/WidgetSources';

import 'external-svg-loader';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
    beforeSend(event) {
      // Prevents reporting of the issues from the dependencies
      if (event.location && event.location.indexOf('./node_modules') === 0) {
        event = null;
        return event;
      }
      // do not log canceled requests
      if (
        (event.extra && event.extra.__serialized__ && event.extra.__serialized__.message === 'canceled') ||
        (event.exception && event.exception.values.find(exception => exception.value.indexOf('canceled') >= 0))
      ) {
        event = null;
        return event;
      }
      // Do not log failed requests
      if (event && event.exception && event.exception.values.find(exception => exception.value.indexOf('Request failed') === 0)) {
        event = null;
      }
      return event;
    },
  });
}

// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = jQuery;
window.emojione = emojione;
window.rangy = rangy;
window.Undo = Undo;
window.eventBus = EventBus;
/** Flag for enabling multi contact exports to be available. If false then only the leatest one will be shown. */
window.useMultiExport = false;
window.SBstore = store;

require('./helpers/validator');

// Vue.use(VueTheMask);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueClipboards);
Vue.use(Clipboard);
Vue.use(VueCookies);
Vue.use(VueSecureHTML);
// Vue.use(VeeValidate, { events: '', fieldsBagName: 'veeFields' }); // TODO convert all veeFields to new validation
Vue.use(VueHighlightJS, {
  languages: {
    css: HJScss,
    javascript: HJSjavascript,
    json: HJSjson,
    xml: HJSxml,
  },
});
Vue.use(Vue2Filters);
Vue.use(InfoModal);
Vue.use(NumberInfoModal);
Vue.use(PasswordConfirmPluginModal);
Vue.use(ConfirmPluginModal);
Vue.use(vClickOutside);
Vue.use(VueDragscroll);
Vue.use(vueFilterPrettyBytes);
Vue.use(VueObserveVisibility); // CS for detecting bottom on scrolling lists - v-observe-visibility directive
Vue.use(VueVirtualScroller);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('icon', Icon);
Vue.component('SBCustomWrapperJSONForms', SBCustomWrapperJSONForms);
Vue.component('BInputWrapper', BInputWrapper);
Vue.component('SBDropdownWrapper', SBDropdownWrapper);
Vue.component('SBTextareaWrapper', SBTextareaWrapper);
Vue.component('NMBRButtonsWrapper', NMBRButtonsWrapper);
Vue.component('NMBRActionsWrapper', NMBRActionsWrapper);
Vue.component('DividerWrapper', DividerWrapper);
Vue.component('SkeletonWrapper', SkeletonWrapper);
Vue.component('FileInputWrapper', FileInputWrapper);
Vue.component('UrlInputWrapper', UrlInputWrapper);
Vue.component('RemoteDataForm', RemoteDataForm);
Vue.component('NMBRRadioWrapper', NMBRRadioWrapper);
Vue.component('DurationWrapper', DurationWrapper);
Vue.component('CustomValidator', CustomValidator);
Vue.component('QuestionsWrapper', QuestionsWrapper);
Vue.component('QuestionsListModalWrapper', QuestionsListModalWrapper);
Vue.component('InputListWrapper', InputListWrapper);
Vue.component('ConversationWrapper', ConversationWrapper);
Vue.component('WarningBubble', WarningBubble);
Vue.component('WidgetSources', WidgetSources);

Vue.directive('select-overflow', MultiselectOverflowFixDirective);
Vue.directive('progress-border', ProgressBorderDirective);
Vue.directive('to-clipboard', CopyToClipboardDirective);

Vue.prototype.$lodash = lodash;
Vue.prototype.$env = process.env;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$moment = moment;
Vue.prototype.$hasPermission = hasPermissionInMerchant; // not used anymore
Vue.prototype.$hasPermissionInOrganisation = hasPermissionInOrganisation;
Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    /**
     * Helper to test empty objects.
     *
     * @param someObject Object to test
     */
    emptyObject(someObject) {
      return Object.keys(someObject).length === 0 && someObject.constructor === Object;
    },
    /**
     * Test if the provided value is object.
     * @param testObject Object to test
     */
    isObject(testObject) {
      return (typeof testObject === 'object' && testObject !== null);
    },
    sortObjectByKeys: (object, { desc = false } = {}) => Object.fromEntries(
      Object.entries(object).sort(([k1], [k2]) => (k1 < k2 || desc ? -1 : 1)),
    ),
    isNetworkError(error) {
      return error.message === 'Network Error';
    },
    isPromise(value) {
      return value instanceof Promise;
    },
    /**
     * Filters the object and returns the part of the object at the path provided.
     * e.g. 'firstChild.secondChild.thirdChild' will return full copy of object.firstChild.secondChild.thirdChild value.
     * If the path is not valid it will return null.
     *
     * @param {Object} object - Object to filter.
     * @param {String} path - Path to the object part that needs to be returned.
     */
    getObjectCopyByPath(object, path) {
      let objectCopy = JSON.parse(JSON.stringify(object));
      path = path ? path.split('.') : [];
      try {
        path.forEach((step) => {
          objectCopy = objectCopy[step];
        });
      } catch (e) {
        return null;
      }
      return objectCopy;
    },

    /**
     * Finds a specified key inside the provided object. It will return first instance of a key it finds.
     * @param {Object} object Object to search in.
     * @param {string} inputKey Key to be searched for inside an object.
     * @returns {*} Copy of a value for the key or null if the key is not found.
     */
    getObjectCopyByKey(object, inputKey, copy = true) {
      const objectCopy = copy ? JSON.parse(JSON.stringify(object)) : object;
      let targetValue = null;

      const processSchema = (schema) => {
        if (schema && typeof schema === 'object') {
          Object.keys(schema).some((key) => {
            const isObject = typeof schema[key] === 'object';
            const isArray = Array.isArray(schema[key]);
            if (key === inputKey) {
              targetValue = schema[key];
              return true;
            }
            if (isArray) {
              // In case the key value is of type Array filter out all the non object values since those can't be iterated any further, then recursively iterate remaining items.
              schema[key] = schema[key].filter(item => typeof item === 'object');
              schema[key].forEach(item => processSchema(item));
            } else if (isObject) {
              // Objects need to be processed recursively.
              processSchema(schema[key]);
            }
            return false;
          });
        }
      };

      processSchema(objectCopy);
      return targetValue;
    },
    getPathForTheProvidedKey(obj, targetKey) {
      function search(currentObj, path = []) {
        if (typeof currentObj !== 'object' || currentObj === null) return null;
        const rootIsArray = Array.isArray(currentObj);
    
        for (let key in currentObj) {
          const newPath = [...path, rootIsArray ? key : key];
          if (key === targetKey) {
            return newPath.join('.');
          }
    
          const result = search(currentObj[key], newPath);
          if (result) return result;
        }
    
        return null;
      }
    
      return search(obj);
    },
  },
});

locale.use(lang);
router.beforeEach(async (to, from, next) => {
  // load app important data
  if (tokenCheck()) {
    await loadAppData();
  }
  // console.log('NEXT');
  next();
});

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID },
}, router);
window.sbgtag = Vue.$gtag;

console.log(':::::::::::::::::::::::::::::::::::::::::::::::::::::');
console.log(`%c::  %AI Number %c😎 ${process.env.NODE_ENV}`, 'color: auto', 'color: orange', 'color: auto');
console.log('::  Build time: ', moment(false, false).unix(process.env.VUE_APP_BUILD_TIME).format('YYYY-MM-DD HH:mm:ss'), `(${process.env.VUE_APP_BUILD_TIME})`);
console.log('::  Version: ', process.env.VUE_APP_VERSION);
console.log(':::::::::::::::::::::::::::::::::::::::::::::::::::::');

// EMOJI FIX - Wrap emoji in span with lass 'emoji-fix' in order for this fix to work
// Check if browser pixel density is higher than 1
function isHighResolutionScreen() {
  return window.devicePixelRatio >= 2;
}

// Check if browser is Chrome so the emoji fix can be applied
function isChrome() {
  let isChrome = false;
  if (navigator.userAgent.indexOf('Chrome/') !== -1) {
    isChrome = true;
  }
  return isChrome;
}

function checkIfLowDensityChrome() {
  if (isChrome() && isHighResolutionScreen()) {
    document.body.classList.add('chrome');
  } else {
    document.body.classList.remove('chrome');
  }
}

// Run once on load
checkIfLowDensityChrome();
// Run again on every resize
window.addEventListener('resize', checkIfLowDensityChrome);

// Run again if mouseout but on specific interval. Focus and blur do not work good here.
let interval;
window.addEventListener('mouseout', (evt) => {
  if (evt.toElement === null && evt.relatedTarget === null) {
    interval = setInterval(() => {
      checkIfLowDensityChrome();
    }, 2500);
  } else {
    clearInterval(interval);
  }
});
// EMOJI FIX end

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
